import { grpc } from "@improbable-eng/grpc-web";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { CloseRounded } from "@mui/icons-material";

import { HeartIntuneProfileService } from "api/models/heartintune-profile-service/heartintune-profile_pb_service";
import { HEARTINTUNE_PROFILE_SERVICE_HOST } from "api/serviceEndpoints";
import { forceLogout, getKeycloakToken } from "config/keycloak";
import React, { ReactElement, useEffect, useMemo, useState } from "react";
import { RequestSetUserRole, RoleMap, Status } from "api/models/heartintune-profile-service/heartintune-profile_pb";
import { PRECEPTOR_OPTION, USER_ROLES } from "constants/role";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";

export default function UpdateRoleModal({
  user,
  open,
  onClose,
  setSnackBar,
}: // setsearchUser,
any): ReactElement {
  const [role, setRole] = React.useState<number>();
  const rolesOption = user?.role === 5 ? [...USER_ROLES, PRECEPTOR_OPTION] : USER_ROLES;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 20;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        margin:20,
      },
    },
  };

  useEffect(() => {
    setRole(user?.role);
  }, [user]);


  const updateUSerRole = async () => {
    try {
      const jwtToken = await getKeycloakToken();
      const reqBody: RequestSetUserRole = new RequestSetUserRole();
      reqBody.setUserid(user?.id);
      const value = role as RoleMap[keyof RoleMap];
      reqBody.setUserrole(value);
      grpc.unary(HeartIntuneProfileService.setUserRole, {
        host: HEARTINTUNE_PROFILE_SERVICE_HOST,
        request: reqBody,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<Status>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK) {
            setSnackBar({
              open: true,
              severity: "success",
              message: "Role has been updated successfully",
            });
            onClose(true);
          } else if (status === grpc.Code.Unauthenticated) { 
            forceLogout(); 
          } else {
            setSnackBar({
              open: true,
              severity: "error",
              message:
                "Unable to update the selected role.",
            });
          }
        },
      });
    } catch (err) {
      //   setIsLoading(false);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Error in  update role",
      });
      console.log(err);
    }
  };
  return (
    <>
      <Dialog
        maxWidth="md"
        open={open}
        TransitionProps={{
            //onEntered: _onOpen,
          }}>
            <DialogTitle
              style={{ backgroundColor: "var(--grey-white)", width: 650 }}
            >
              <Typography variant="h6" component="span">
                Update Role
              </Typography>
              <IconButton
                style={{ position: "absolute", right: 0, top: 8 }}
                onClick={() => {
                  onClose(false);
                }}
                size="large"
              >
                <CloseRounded color="disabled" />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers className="">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Role
                  </InputLabel>
                  <Select
                      defaultValue={role}
                      onChange={(e: SelectChangeEvent<number>) =>
                        setRole(e.target.value as number)
                      }
                      label="Select role"
                      MenuProps={MenuProps}
                    >
                      {Array.isArray(rolesOption) && rolesOption.map((r) => (
                        <MenuItem key={r.value} value={r.value}>
                          {r.role}
                        </MenuItem>
                      ))}
                    </Select>
                </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid className="px-3 py-2">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => updateUSerRole()}
                >
                  Update
                </Button>
              </Grid>
            </DialogActions>
      </Dialog>
    </>
  );
}
